import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsOverview = () => {
  const metricsData = [
    {
      id: 1,
      title: "Toplam Çağrı",
      value: "2,847",
      change: "+12.5%",
      changeType: "increase",
      icon: "Phone",
      color: "bg-blue-500"
    },
    {
      id: 2,
      title: "Ortalama Bekleme Süresi",
      value: "2:34",
      change: "-8.2%",
      changeType: "decrease",
      icon: "Clock",
      color: "bg-green-500"
    },
    {
      id: 3,
      title: "İlk Çağrıda Çözüm",
      value: "87.3%",
      change: "+3.1%",
      changeType: "increase",
      icon: "CheckCircle",
      color: "bg-emerald-500"
    },
    {
      id: 4,
      title: "Müşteri Memnuniyeti",
      value: "4.6/5",
      change: "+0.2",
      changeType: "increase",
      icon: "Star",
      color: "bg-yellow-500"
    },
    {
      id: 5,
      title: "Terk Oranı",
      value: "3.8%",
      change: "-1.2%",
      changeType: "decrease",
      icon: "PhoneOff",
      color: "bg-red-500"
    },
    {
      id: 6,
      title: "Hizmet Seviyesi",
      value: "94.2%",
      change: "+2.8%",
      changeType: "increase",
      icon: "Target",
      color: "bg-purple-500"
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
      {metricsData?.map((metric) => (
        <div key={metric?.id} className="bg-white rounded-lg border border-slate-200 p-6 shadow-subtle hover:shadow-elevated transition-shadow duration-200">
          <div className="flex items-center justify-between mb-4">
            <div className={`w-12 h-12 ${metric?.color} rounded-lg flex items-center justify-center`}>
              <Icon name={metric?.icon} size={24} color="white" />
            </div>
            <div className={`flex items-center space-x-1 text-sm font-medium ${
              metric?.changeType === 'increase' ? 'text-green-600' : 'text-red-600'
            }`}>
              <Icon 
                name={metric?.changeType === 'increase' ? 'TrendingUp' : 'TrendingDown'} 
                size={16} 
              />
              <span>{metric?.change}</span>
            </div>
          </div>
          
          <div className="space-y-1">
            <h3 className="text-2xl font-bold text-slate-900">{metric?.value}</h3>
            <p className="text-sm text-slate-600">{metric?.title}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MetricsOverview;